import { Controller } from '@hotwired/stimulus'
import throttle from 'lodash.throttle'
import * as domHelpers from 'bali/utils/domHelpers'

export default class FixedNavbarWithBanner extends Controller {
  static targets = ['banner', 'navbar']
  static values = { throttleInterval: { type: Number, default: 10 } }

  connect = () => {
    this.throttledUpdateTopPosition = throttle(this.updateTopPosition, this.throttleIntervalValue)
    document.addEventListener('scroll', this.throttledUpdateTopPosition)
  }

  updateTopPosition = () => {
    if (!domHelpers.isElementInViewport(this.bannerTarget)) {
      this.navbarTarget.style.top = 0
      return
    }

    const { bottom: bannerBottom, height: bannerHeight } = this.bannerTarget.getBoundingClientRect()

    if (bannerBottom > 0) {
      this.navbarTarget.style.top = `${bannerBottom}px`
    } else {
      this.navbarTarget.style.top = `${bannerHeight}px`
    }
  }
}
